import { createShader, colorUniform } from "./ShaderBase.js";

export const glitchShader = createShader({
  customizable: [
    { uniform: "uColorBg", label: "Background", default: "#0a0a0a" },
    { uniform: "uColorGlow", label: "Glow", default: "#00ff41" },
  ],

  uniforms: {
    uPixelSize: { value: 16.0 },
    uScale: { value: 1.0 },
    uSpeed: { value: 2.0 },
    uColorBg: colorUniform("#0a0a0a"),
    uColorGlow: colorUniform("#00ff41"),
    uGlitchDensity: { value: 0.85 },
    uGlitchIntensity: { value: 0.8 },
  },

  fragmentUniforms: `
    uniform vec3 uColorBg;
    uniform vec3 uColorGlow;
    uniform float uGlitchDensity;
    uniform float uGlitchIntensity;
  `,

  fragmentBody: `
    // Base is dark background
    vec3 color = uColorBg;

    // Glitch blocks - use stepped time for that digital flicker
    float stepTime = floor(uTime * uSpeed * 5.0);

    // Primary glitch layer - random blocks
    vec3 glitchPos1 = pixelatedPos * 8.0 + vec3(stepTime * 0.1, stepTime * 0.07, 0.0);
    float glitch1 = snoise(glitchPos1);
    float block1 = step(uGlitchDensity, (glitch1 + 1.0) * 0.5);

    // Secondary layer - slower, larger blocks
    float stepTime2 = floor(uTime * uSpeed * 2.0);
    vec3 glitchPos2 = pixelatedPos * 3.0 + vec3(stepTime2 * 0.05, stepTime2 * 0.03, 0.0);
    float glitch2 = snoise(glitchPos2);
    float block2 = step(0.92, (glitch2 + 1.0) * 0.5);

    // Scanline effect
    float scanline = step(0.5, fract(pixelatedPos.y * 2.0));
    float scanDim = 0.85 + scanline * 0.15;

    // Combine glitch blocks
    float totalGlitch = max(block1, block2 * 0.7);

    // Add glow color with slight variation
    vec3 glowColor = uColorGlow * (0.8 + glitch1 * 0.2);
    color = mix(color, glowColor * uGlitchIntensity, totalGlitch);

    // Apply scanline dimming
    color *= scanDim;

    // Occasional bright flash pixels
    float flashNoise = snoise(pixelatedPos * 50.0 + vec3(stepTime));
    float flash = step(0.98, (flashNoise + 1.0) * 0.5);
    color = mix(color, vec3(1.0), flash * 0.5);

    gl_FragColor = vec4(color, 1.0);
  `,
});
